import { useEffect } from 'react';

/** Exposes the sticky header height as --app-sticky-header-height (used for scroll-padding, WCAG 2.4.11). */
export function useStickyHeaderOffset(): void {
  useEffect(() => {
    const header = document.querySelector<HTMLElement>('.idsk-header-web');
    if (!header || typeof ResizeObserver === 'undefined') return;
    const update = () => {
      const sticky = getComputedStyle(header).position === 'sticky';
      document.documentElement.style.setProperty('--app-sticky-header-height', sticky ? `${header.offsetHeight + 8}px` : '0px');
    };
    const observer = new ResizeObserver(update);
    observer.observe(header);
    window.addEventListener('resize', update);
    update();
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', update);
    };
  });
}
